exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "th {\n  background: none repeat scroll 0 0 #00bcd4;\n  color: #f5f5f5;\n  font-size: 1.5vh !important;\n  font-weight: bold;\n  line-height: 2;\n  padding: 0.5rem 0.625rem 0.625rem;\n  position: relative;\n  text-transform: uppercase;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/surgeon-procedures/surgeon-procedures.component.scss
// module id = ../../../../../src/app/surgeon-procedures/surgeon-procedures.component.scss
// module chunks = main